<template>
  <div>
    <v-toolbar app flat color="secondary" dark :extended="isDashboard" extension-height="48" class="v2-appbar">
      <router-link :to="{ name: 'V2Dashboard' }" class="v2-brand">
        <img src="/favicon.png" alt="" class="v2-logo" />
        <span class="v2-wordmark hidden-xs-only">Syndawiz</span>
      </router-link>
      <v-divider vertical class="v2-bar-divider hidden-xs-only"></v-divider>
      <span class="v2-page-title">{{ pageTitle }}</span>
      <v-spacer></v-spacer>

      <template v-if="showSwitcher">
        <v-autocomplete
          v-if="$vuetify.breakpoint.smAndUp"
          @change="changeSyndicate"
          v-model="selected_syndicate_id"
          :items="syndicates"
          item-text="syndicate_abbreviation"
          item-value="id"
          placeholder="Switch view"
          prepend-inner-icon="swap_horiz"
          solo flat hide-details
          class="v2-switcher mr-3"
        ></v-autocomplete>
        <v-menu v-else :close-on-content-click="false" offset-y>
          <v-btn slot="activator" icon><v-icon>swap_horiz</v-icon></v-btn>
          <v-card class="pa-2" width="260">
            <v-autocomplete
              @change="changeSyndicate"
              v-model="selected_syndicate_id"
              :items="syndicates"
              item-text="syndicate_abbreviation"
              item-value="id"
              label="Switch View"
              outline hide-details
            ></v-autocomplete>
          </v-card>
        </v-menu>
      </template>

      <v-btn v-if="!isDashboard" flat :icon="$vuetify.breakpoint.xsOnly" :to="{ name: 'V2Dashboard' }" class="v2-bar-btn">
        <v-icon small :left="$vuetify.breakpoint.smAndUp">dashboard</v-icon>
        <span class="hidden-xs-only">Dashboard</span>
      </v-btn>
      <v-btn v-if="userpermission.syndcation_manager" flat :icon="$vuetify.breakpoint.xsOnly" :to="{ name: 'V2SuperSyndicate' }" class="v2-bar-btn">
        <v-icon small :left="$vuetify.breakpoint.smAndUp">account_tree</v-icon>
        <span class="hidden-xs-only">Super Syndicate</span>
      </v-btn>

      <v-menu offset-y left>
        <v-btn slot="activator" icon class="v2-avatar-btn ml-1">
          <v-avatar size="34" color="primary"><span class="white--text font-weight-bold">{{ initials }}</span></v-avatar>
        </v-btn>
        <v-list dense>
          <v-list-tile :to="{ name: 'V2Dashboard' }">
            <v-list-tile-action><v-icon>dashboard</v-icon></v-list-tile-action>
            <v-list-tile-title>Dashboard</v-list-tile-title>
          </v-list-tile>
          <v-list-tile :to="{ name: 'V2Profile' }">
            <v-list-tile-action><v-icon>account_box</v-icon></v-list-tile-action>
            <v-list-tile-title>My Profile</v-list-tile-title>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile @click="logout">
            <v-list-tile-action><v-icon>exit_to_app</v-icon></v-list-tile-action>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-tabs
        v-if="isDashboard"
        slot="extension"
        color="transparent"
        slider-color="accent"
        dark
        class="v2-tabs"
      >
        <v2-tab v-for="t in visibleTabs" :key="t.name" :to="{ name: t.name }">{{ t.label }}</v2-tab>
      </v-tabs>
    </v-toolbar>

    <v-content>
      <div class="v2-root">
        <router-view></router-view>
      </div>
    </v-content>
  </div>
</template>

<script>
import VTab from 'vuetify/es5/components/VTabs/VTab'
import user_helper from '../../helpers/user_helper'
import v2Theme from '../mixins/v2Theme'
import '../styles/v2.css'

const PAGE_TITLES = {
  V2SuperSyndicate: 'Super Syndicate',
  V2Profile: 'My Profile',
  V2Fcs: 'File Control Sheet',
  V2AcceptOffer: 'Accept Offer',
  V2AccountingReply: 'Request Adjustment',
}

export default {
  mixins: [user_helper, v2Theme],
  components: { 'v2-tab': VTab },
  computed: {
    isDashboard() {
      return (this.$route.name || '').startsWith('V2Dashboard')
    },
    pageTitle() {
      return PAGE_TITLES[this.$route.name] || `${localStorage.getItem('name')} Portfolio`
    },
    showSwitcher() {
      return !!this.userpermission.syndcation_manager && this.$route.name !== 'V2SuperSyndicate'
    },
    initials() {
      return (localStorage.getItem('name') || '')
        .split(' ')
        .map(w => w[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()
    },
    visibleTabs() {
      const m = this.mainSyndicate || {}
      return [
        { name: 'V2DashboardSimple', label: 'Simple View' },
        m.show_detailed_view_tab && { name: 'V2DashboardDetailed', label: 'Detailed View' },
        { name: 'V2DashboardPayouts', label: 'Payouts' },
        m.deals_tab && { name: 'V2DashboardDeals', label: 'Syndicated Deals' },
      ].filter(Boolean)
    },
  },
  methods: {
    logout() {
      const keep = ['last_syndication_id', 'remember_me'].map(k => [k, localStorage.getItem(k)])
      localStorage.clear()
      keep.forEach(([k, v]) => v && v != 'null' && localStorage.setItem(k, v))
      this.$router.push('/login')
    },
  },
}
</script>
